export const EXTENDED_BENEFITS_REPORT_FETCHING =
  'EXTENDED_BENEFITS_REPORT_FETCHING';
export const EXTENDED_BENEFITS_GET_REPORT = 'EXTENDED_BENEFITS_GET_REPORT';
export const EXTENDED_BENEFITS_FETCH_ERROR = 'EXTENDED_BENEFITS_FETCH_ERROR';
export const EXTENDED_BENEFITS_CLEAR_REPORT = 'EXTENDED_BENEFITS_CLEAR_REPORT';
export const EXTENDED_BENEFITS_GET_EXCEL_REPORT =
  'EXTENDED_BENEFITS_GET_EXCEL_REPORT';



// WEBPACK FOOTER //
// ./src/pages/extendedbenefits/state/report/types.js